import { NavLink } from 'react-router-dom';

import {
  IconChevronDown as ChevronDownSVG,
  IconChevronUp as ChevronUpSVG,
  IconBrandingStyleguide as BrandingStyleguideSVG,
} from '../../../core';
import { Menus, NavigationTab } from '../types';

import CompactTab from './CompactTab';

const BrandingStyleguide = ({
  handleMenuCollapse,
  collapsedMenus,
  isMenuClosed,
  setIsMenuClosed,
}: Omit<NavigationTab, 'collapsedSubMenus'>) => {
  const link = '/branding-styleguide';

  if (isMenuClosed)
    return (
      <CompactTab
        menuOption={Menus.BRANDING_STYLEGUIDE}
        icon={<BrandingStyleguideSVG />}
        handleMenuCollapse={handleMenuCollapse}
        setIsMenuClosed={setIsMenuClosed}
        href={link}
      />
    );

  return (
    <li>
      <NavLink
        to={link}
        className={({ isActive }) => (isActive ? 'active' : '')}
        onClick={() => handleMenuCollapse(Menus.BRANDING_STYLEGUIDE)}
      >
        <>
          <div>
            <BrandingStyleguideSVG />
            <span>Branding Styleguide</span>
          </div>
          {collapsedMenus.includes(Menus.BRANDING_STYLEGUIDE) ? (
            <ChevronDownSVG />
          ) : (
            <ChevronUpSVG />
          )}
        </>
      </NavLink>
      <ul
        className={`lvl-2 ${collapsedMenus.includes(Menus.BRANDING_STYLEGUIDE) ? 'collapsed' : ''}`}
      >
        <li>
          <NavLink
            to="/branding-styleguide/colors"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Colors</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/branding-styleguide/typography"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Typography</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/branding-styleguide/logos"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Logos</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/branding-styleguide/icons"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Iconography & Graphics</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/branding-styleguide/imagery"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Imagery</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/branding-styleguide/interactions-and-animations"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Interactions and Animations</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/branding-styleguide/brand-in-use"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Brand in Use</span>
          </NavLink>
        </li>
      </ul>
    </li>
  );
};

export default BrandingStyleguide;
